import { useState } from 'react';
import { SortMode } from '../types';
import { HeaderContainer, ReportTitle, TitleGroup } from '../styles';
import { IconButton, Menu, MenuItem } from '@mui/material';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

export const ReportsListHeader = ({
  isVisible,
  onToggleReportsList,
  onChangeSortMode,
  sortMode,
}: {
  isVisible: boolean;
  onToggleReportsList: () => void;
  onChangeSortMode: (sortMode: SortMode) => void;
  sortMode: SortMode;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <HeaderContainer isVisible={isVisible}>
      {isVisible && (
        <TitleGroup>
          <ReportTitle variant="h6">Report List</ReportTitle>
          <IconButton title="sort reports" onClick={handleClick}>
            <SwapVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem
              selected={sortMode === SortMode.NEWEST}
              onClick={() => {
                onChangeSortMode(SortMode.NEWEST);
                handleClose();
              }}
            >
              Newest
            </MenuItem>
            <MenuItem
              selected={sortMode === SortMode.OLDEST}
              onClick={() => {
                onChangeSortMode(SortMode.OLDEST);
                handleClose();
              }}
            >
              Oldest
            </MenuItem>
            <MenuItem
              selected={sortMode === SortMode.CATEGORY}
              onClick={() => {
                onChangeSortMode(SortMode.CATEGORY);
                handleClose();
              }}
            >
              Category
            </MenuItem>
          </Menu>
        </TitleGroup>
      )}
      <IconButton onClick={onToggleReportsList} title={isVisible ? 'hide reports' : 'show reports'}>
        {isVisible ? <CloseIcon /> : <KeyboardArrowRightIcon />}
      </IconButton>
    </HeaderContainer>
  );
};
